import React, { Component } from 'react'
import './App.css'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { coreapiMiddleware } from 'redux-coreapi'
import { reducer as formReducer } from 'redux-form'
import createHistory from 'history/createBrowserHistory'
import thunk from 'redux-thunk'
import { jssPreset, StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import axios from 'axios'
import Root from './containers/Root'
import schema from './reducers/schema'
import authorization from './reducers/authorization'
import restApi from './reducers/restApi'
import tableState from './reducers/tableState'
import { create } from 'jss'
import jssExtend from 'jss-plugin-extend'

export const axiosApi = axios.create({
  // headers: { 'X-CSRFToken': csrfToken },
})

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory(

)

// Build the middleware for intercepting and dispatching navigation actions
// const routerMiddlewareWithHistory = routerMiddleware(history)

// REDUX
const reducers = {
  authorization,
  // alerts,
  schema,
  restApi,
  // appState,
  tableState,
  form: formReducer,
  // router: connectRouter(history)
}

const combinedReducer = combineReducers(reducers)

/** @namespace window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ **/
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(combinedReducer, composeEnhancers(
  applyMiddleware(thunk,
    coreapiMiddleware)
))

// global conf

const appSettings = {
  dateFormat: 'D MMM, ddd',
  dateTimeFormat: 'D MMM, ddd hh:mm',
}

export { appSettings }

// MUI Theme
// appbar
// #026A8D
// button
// #024F69
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#D60A15',
    },
    secondary: {
      main: '#CB8456',
    },
  },
  typography: {
    // Use the system font.
    fontSize: 11,
    fontFamily:
      '"Sporting Grotesque", "Roboto", "Helvetica", "Arial", sans-serif',
    body1: {
      fontSize: 11,
    },
    h1: {
      fontSize: 24,
    },
  },
  // move modals 100 higher so wee can fit a overlay over the drawer
  // zIndex: {
    // drawer: 1200,
    // modal: 1500,
    // snackbar: 1600,
    // tooltip: 1700,
  // }
})

// add JSS plugins
const jss = create({
  plugins: [jssExtend(), ...jssPreset().plugins]
})

class App extends Component {
  render () {
    return (
      <StylesProvider jss={jss}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline/>
          <Root history={history} store={store}/>
        </MuiThemeProvider>
      </StylesProvider>
    )
  }
}

export default App
